import React, { useState } from 'react';
import { Box } from 'pcln-design-system';
import { SimpleMarkdownElement } from './SimpleMarkdownElement';
export const SimpleMarkdownLine = props => {
  const {
    elements,
    handleMapButtonClick
  } = props;
  const [lineMarginLeft, setLineMarginLeft] = useState(0);
  const pinsInCurrentLine = elements.filter(element => {
    var _a;
    return (element === null || element === void 0 ? void 0 : element.metadata) && ((_a = element === null || element === void 0 ? void 0 : element.metadata) === null || _a === void 0 ? void 0 : _a.type) !== 'CITATION';
  }).map(element => element.metadata);
  return React.createElement(Box, {
    ml: lineMarginLeft
  }, elements.map((element, i) => {
    return React.createElement(React.Fragment, {
      key: `markdown-element-${i}`
    }, React.createElement(SimpleMarkdownElement, {
      element: element,
      setLineMarginLeft: setLineMarginLeft,
      handleMapButtonClick: handleMapButtonClick,
      pinsInCurrentLine: pinsInCurrentLine
    }));
  }));
};